module.exports = "<svg viewBox=\"0 0 24 24\"><path d=\"M3,15 L3,13 L21,13 L21,15 L3,15 Z M3,11 L3,9 L21,9 L21,11 L3,11 Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./components/UI/Icon/images/drag-handle.svg
// module id = 775
// module chunks = 0